// src/pages/Accounts/supplierPaymentThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCreditorPayWithDetailsApi,
  getCreditorPaymentCodesApi,
  getDuePurchaseVoucherApi,
  getSundryCreditorBalanceApi,
  saveCreditorPaymentApi,
  deleteCreditorPaymentApi,
  getVoucherSupplierBalanceApi,
  getAccountBalanceApi,
  getDueSalesReturnVouchers,
} from "../../apiservice/accounts";
import { getAccountByTypeApi } from "../../apiservice/setting";

// fetch all supplier payments (with details)
export const fetchPayments = createAsyncThunk(
  "supplierPayments/fetchPayments",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCreditorPayWithDetailsApi({ oneDate: null });
      // backend returns array in res.data
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch new payment code
export const fetchPaymentCode = createAsyncThunk(
  "supplierPayments/fetchPaymentCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCreditorPaymentCodesApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch due purchase vouchers for supplier
export const fetchDueVouchers = createAsyncThunk(
  "supplierPayments/fetchDueVouchers",
  async (supplierId, { rejectWithValue }) => {
    try {
      const res = await getVoucherSupplierBalanceApi({ supplierId });
      return { supplierId, vouchers: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDueCustomerReturns = createAsyncThunk(
  "supplierPayments/fetchDueCustomerReturns",
  async (customerId, { rejectWithValue }) => {
    try {
      const res = await getDueSalesReturnVouchers({ customerId });
      return { customerId, returns: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch supplier balance (sundry creditor)
export const fetchSupplierBalance = createAsyncThunk(
  "supplierPayments/fetchSupplierBalance",
  async (supplierId, { rejectWithValue }) => {
    try {
      const res = await getSundryCreditorBalanceApi({ supplierId });
      return { supplierId,   balance: {
    total_balance: res.data.total_balance,
    opening_balance: res.data.opening_balance,
  },};
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchAccountBalance = createAsyncThunk(
  "supplierPayments/fetchAccountBalance",
  async (acc, { rejectWithValue }) => {

    try {
      const res = await getAccountBalanceApi({
        accId: acc.acc_id,
        accType: acc.accType,
      });
      return { accId: acc.acc_id, balance: res.data.total_balance };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// save (create / update) payment
export const savePayment = createAsyncThunk(
  "supplierPayments/savePayment",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveCreditorPaymentApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete payment
export const deletePayment = createAsyncThunk(
  "supplierPayments/deletePayment",
  async (pay_id, { rejectWithValue }) => {
    try {
      const res = await deleteCreditorPaymentApi({ pay_id });
      return { id: pay_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCurrentliablityAccounts = createAsyncThunk(
  "supplierPayments/fetchCurrentliablityAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "dutie_&_tax" });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDirectIncomeAccounts = createAsyncThunk(
  "supplierPayments/fetchDirectIncomeAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "direct_income" });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
